'use strict';

module.exports = {
  // TIME-ZONES
  DEFAULT_UTC_OFFSET: 0,

  // TIME IN MINUTES
  FIVE_MINUTES: 5,
  QUARTERS_IN_ONE_HOUR: 4,
  QUARTER_HOUR: 15,
  HALF_HOUR: 30,
  THREE_QUARTER_HOUR: 45,
  ONE_HOUR: 60,

  // TIME CONVERSION
  ONE_SECOND_IN_MS: 1000,
  ONE_SECOND_IN_NS: 1e9,
  ONE_HOUR_IN_SEC: 3600,
  ONE_HOUR_IN_MINUTES: 60,
  ONE_HOUR_IN_MS: 3600000,
  ONE_MINUTE_IN_MS: 60000,
  ONE_MINUTE_IN_SEC: 60,
  ONE_DAY_IN_HOURS: 24,
  NANO_TO_MS: 1000000,
};
